<div class="filter-container">
  <form class="filter-row" (submit)="submit()">
    <glxy-form-field bottomSpacing="none" class="namespace-type-filter">
      <glxy-label>Namespace Type</glxy-label>
      <mat-select (selectionChange)="namespaceTypeChange($event.value)" [formControl]="form.controls.namespaceType">
        @for (option of namespaceTypeOptions; track option.value) {
          <mat-option [value]="option">{{ option.label }}</mat-option>
        }
      </mat-select>
    </glxy-form-field>

    @if (form.get('namespaceType')?.value?.hasId) {
      <glxy-form-field bottomSpacing="none" class="namespace-id-filter">
        <glxy-label>{{ form.get('namespaceType')?.value?.idLabel }}</glxy-label>
        <input type="text" matInput [formControl]="form.controls.namespaceId" placeholder="Filter by ID" />
      </glxy-form-field>
    }
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">Submit</button>
  </form>
</div>
